'use strict';

var React = require('react');
var number = require('../../helpers/number.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const avatarColors = ['blue', 'green', 'grey', 'orange', 'purple', 'red'];
const Avatar = React.forwardRef(({ color, size = 'm', initials, src, ...props }, ref) => {
    const computedColor = React.useMemo(() => color ?? avatarColors[number.random({ max: avatarColors.length - 1 })], [color]);
    return (React__default.default.createElement(styles.Styled.Container, { ...props, size: size, color: computedColor, ref: ref, src: src },
        React__default.default.createElement(styles.Styled.Text, { variant: "body" }, !src ? initials.toUpperCase() : '')));
});

exports.Avatar = Avatar;
exports.avatarColors = avatarColors;
//# sourceMappingURL=component.js.map
